import EnrolmentList from "./components/List"
import EnrolmentListOrganisations from "./components/ListOrganisations"
import EnrolmentView from "./components/FormBasic"
import EnrolmentViewOrganisation from "./components/ViewOrganisation"

let module = "enrolments"
let module_org = "enrolments-organisation"

export default [
  { path: "enrolments", component: EnrolmentList, meta: { module: module, permissions: ["enrolment-access"] } },
  {
    path: "enrolments/view/:id",
    component: EnrolmentView,
    props: true,
    meta: { module: module, permissions: ["enrolment-access"] }
  },

  {
    path: "enrolments/organisations/create",
    component: EnrolmentViewOrganisation,
    props: true,
    meta: { module: module_org, permissions: ["enrolment-create"] }
  },
  {
    path: "enrolments/organisations",
    component: EnrolmentListOrganisations,
    props: true,
    meta: { module: module_org, permissions: ["enrolment-access", "companies-access"] }
  },
  {
    path: "enrolments/organisations/view/:id",
    component: EnrolmentViewOrganisation,
    props: true,
    meta: { module: module_org, permissions: ["enrolment-access", "companies-access"] }
  }
]
